import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IProductOverrides } from './types';

export const commitSync = async (payload: IProductOverrides[]) => {
  const res = await fetch(`${API_URL}/items/commit`, {
    method: 'POST',
    body: JSON.stringify({
      product_overrides: payload,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok && res.status !== 202) {
    throw new Error(`Invalid statuscode returned: ${res.status}`);
  }
};
